var $one = function(obj, doc){
  if(doc){
    if(!/element/i.test(doc.toString())){
      doc = $one(doc);
    }
    return doc.querySelector(obj)
  }else{
    return document.querySelector(obj)
  }
}
var $$ = function(obj, doc){
  if(doc){
    if(!/element/i.test(doc.toString())){
      doc = $one(doc);
    }
    return doc.querySelectorAll(obj)
  }else{
    return document.querySelectorAll(obj)
  }
};

function getStyle (obj, attr) { 
  　　return obj.currentStyle ? obj.currentStyle[attr] : getComputedStyle( obj )[attr]; 
}

NodeList.prototype.addEventListener = function(event, fn, useCapture){
  this.forEach(function(element) {
    element.addEventListener(event, fn, useCapture)
  })
} 
NodeList.prototype.show = function (displayType) {
  this.forEach(function(element) {
    element.style.display = displayType ? displayType : 'block';
  });
}
Element.prototype.show = function (displayType) {
  this.style.display = displayType ? displayType : 'block';
}
NodeList.prototype.hide = function () {
  this.forEach(function(element) {
    element.style.display = 'none';
  });
}
Element.prototype.hide = function () {
  this.style.display = 'none';
}

var loadFunctionArr = [];

document.addEventListener('DOMContentLoaded', function() {
 

  $$('[data-copy]').addEventListener('click', function(){
    var couponVal = this.getAttribute('data-copy');
    var text = this.getAttribute('data-text');
    var btnText = this.getAttribute('data-btn');
    copyText(couponVal.trim(), text, undefined, btnText);
    this.innerHTML = btnText;
    return false
  }); 
 
  loadFunctionArr.forEach(function(fn){
    if(typeof fn == 'function'){
      fn();
    }
  });
}, false);


function copyText(val, msg, okFn, btnText) {
  var inputObj = $$('#copyTextInput');
  if(inputObj.length){
    inputObj = inputObj[0];
    inputObj.value = val;
    inputObj.select();
    inputObj.setSelectionRange(0, inputObj.value.length),
        document.execCommand("Copy");
    inputObj.blur();
    var text = msg || "Copied Successfully";
    if(!btnText){
      alert(text).okBtn(function () {
          okFn && okFn();
      });
    }
  }
}


function setFeaturedCollectionTabShow(){
  $$('.section-tabBoxB').forEach(function(element, index){
   var span = element.querySelectorAll('.section-tabTarget-box span');
   var content = element.querySelectorAll('.section-tabBox');
   span.addEventListener('click', function(evevt){
      var index = [].indexOf.call(span, evevt.target);
      console.log(index);
      span.forEach(function(element, ii){
        if(ii == index){
          element.classList.add('active');
        }else{
          element.classList.remove('active');
        }
      });
      span.forEach(function(element, ii){
        if(ii == index){
          element.classList.add('active');
        }else{
          element.classList.remove('active');
        }
      });
      content.forEach(function(element, ii){
        if(ii == index){
          element.show();
        }else{
          element.hide();
        }
      });
   });
  });
 }
 setFeaturedCollectionTabShow();